import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SidebarBox } from './SidebarBox';
import { CourseCardList } from './CourseCardList';
import { type CourseCard } from '../StreamDashboard.types';
import '../locales/streamDashboard/streamDashboard-en.json';

type Props = {
    courses: CourseCard[];
    onSelectCourse: (courseId: string) => void;
    className?: string;
};

export const RelatedCoursesBox: FC<Props> = ({ courses, onSelectCourse, className }) => {
    const { t } = useTranslation('back_royal', { keyPrefix: 'streamDashboard.streamDashboard' });

    if (!courses.length) return null;

    return (
        <SidebarBox caption={t('related_courses')} className={className}>
            <CourseCardList courses={courses} onSelectCourse={onSelectCourse} />
        </SidebarBox>
    );
};
